import {  Button, TextFieldEditor, Spinner } from '../../components';
import { useState } from 'react';
import s from './Login.module.scss';

const LOGIN_BUTTON_LABEL = 'Log in';
const SSO_BUTTON_LABEL = 'Log in with SSO';

export const LoginForm = ({ login, ssoLogin, forgotPassword }) => {
    const [email, setEmail] = useState(''); 
    const [password, setPassword] = useState(''); 
    const [buttonSpinner, setButtonSpinner] = useState(null);
    const buttonDisabled = !(email && password);
    const renderSpinner = (label, color) => (buttonSpinner === label ? <Spinner data-testid={label} loading={true} small color={color} /> : label);

    return <div className={s.loginForm} data-testid="login-form-container">
            <form className={s.formBox} onSubmit={(e) => {
                setButtonSpinner(LOGIN_BUTTON_LABEL);
                login({ email, password, resetSpinner: () => setButtonSpinner(null), e });
            }}>
                <TextFieldEditor firstLetterUppercase={true} big={true} label="email" value={email} onChange={setEmail} />
                <TextFieldEditor firstLetterUppercase={true} big={true} password={true} label="password" value={password} onChange={setPassword} />

                <Button disabled={buttonDisabled} className={s.primaryBtn} label={renderSpinner(LOGIN_BUTTON_LABEL)} />
            </form>
            <Button className={s.ssoBtn} label={renderSpinner(SSO_BUTTON_LABEL, "#2b2b2b")} onClick={() => {
                setButtonSpinner(SSO_BUTTON_LABEL);
                ssoLogin();
            }}/>
            <button type="button" className={s.forgotPassword} data-testid="Forgot password?-button"  onClick={forgotPassword} >Forgot password?</button>
        </div>
}